import React from 'react';
import styles from './styles.scss';



function ProductDetails({
  title,
  color,
  includes,
  description,
  image
}) {
  return (
    <div className="container-fluid main-container">
      <div className="row">
        <div className="col-md-10 col-md-offset-1 col-sm-12">
          <div className="row">
            <div className="col-sm-6">
              <div className={`${styles.title} h1 light`}>
                <span className={styles.bullet} style={{ color }}>&#x25CF;</span>
                {title}
              </div>
              <div className={styles.description}>
                {description}
              </div>
              <div className={styles.includes}>
              <div className="bold mb10" style={{ color }}>
                COMES WITH
              </div>
                <ul>
                  {includes.map((include, index) => {
                    return (
                      <li key={index}>{include}</li>
                    );
                  })}
                </ul>
              </div>
            </div>
            <div className="col-sm-6">
              <img src={image} className={styles.image} alt={title} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProductDetails;



// WEBPACK FOOTER //
// ./src/components/ProductDetails/index.js